// import { v4 } from 'uuid'
import { getUserInfo } from '@/request/user.js'

const lfSignKey = 'S07Eu4zFndWhyzmblfHotel'
// 默认币种
const webCurrency = 'USD'
const collapseVal = true
const collapseValF = false
// 默认语言
const webLanguage = 'English'

// 搜索区域公共变量
const childOld = {1: '<1', 2: '1', 3: '2', 4: '3', 5: '4', 6: '5', 7: '6', 8: '7', 9: '8', 10: '9', 11: '10', 12: '11', 13: '12', 14: '13', 15: '14', 16: '15', 17: '16', 18: '17'}
// 酒店列表公共变量
const levelOptions = {1: '五星/豪华', 2: '四星/高档', 3: '三星/舒适', 4: '二星/经济'}
const levelOptionsRev = {'五星/豪华': '1', '四星/高档': '2', '三星/舒适': '3', '二星/经济': '4'}
const propertyLanguage = {1: 'propertyClass5', 2: 'propertyClass4', 3: 'propertyClass3', 4: 'propertyClass2'}
const levelOptionsEn = {1: 'Property class 5', 2: 'Property class 4', 3: 'Property class 3', 4: 'Property class 2'}
const levelOptionsRevEn = {'Property class 5': '1', 'Property class 4': '2', 'Property class 3': '3', 'Property class 2': '4'}

// 酒店搜索
const weekZh = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
const weekMobileZh = ['日', '一', '二', '三', '四', '五', '六']
const weekPcEn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const weekEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
const monthMobileEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

// mapBox key
const MapBoxKey = 'sk.eyJ1IjoibGV0c2ZseXRlY2giLCJhIjoiY2w2cHhzOTF2MDE1cDNkbGppdnRmaWlvMiJ9.mzxzFDTtywYDyNTM-jTX3Q'
const MapBoxPublicKey = 'pk.eyJ1IjoibGV0c2ZseXRlY2giLCJhIjoiY2w1NjdheHZmMWdhbTNpdGRvenJraXVtcyJ9.G0x_cj55mn5Vq6KkosFtQg'

// 默认搜索信息
const defaultRegion = 'EPS Partner Connect Test'
const defaultRegionId = '1022990'
const defaultRegionType = '3'

export default {
  lfSignKey,
  childOld,
  levelOptions,
  levelOptionsRev,
  levelOptionsEn,
  levelOptionsRevEn,
  propertyLanguage,
  webCurrency,
  collapseVal,
  collapseValF,
  webLanguage,
  MapBoxKey,
  MapBoxPublicKey,
  weekZh,
  weekMobileZh,
  weekPcEn,
  weekEn,
  monthEn,
  monthMobileEn,
  defaultRegion,
  defaultRegionId,
  defaultRegionType,
  encryptionData: function (data, s) {
    var ua = navigator.userAgent
    data['ua'] = ua
    let flag = ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      var isAndroid = ua.match(/(Android|android|Linux)/i)
      var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      data['flag'] = 'mobile'
      data['device'] = isAndroid ? 'Android' : isiOS ? 'IOS' : 'Unknown'
    } else {
      var device = 'Unknown'
      if (ua.match(/(win|Win)/i)) {
        device = 'Windows'
      } else if (ua.match(/(mac|Mac|MAC)/i)) {
        device = 'Mac OS'
      } else if (ua.match(/(pad|pod|iPod|iPad)/i)) {
        device = 'Pad'
      }
      data['device'] = device
      data['flag'] = 'website'
    }
    //
    data['equipmentCode'] = s.IdentificationCode('MD5')

    var that = s

    // // 判断 地址中是否包含source 获取source
    // let params = new URL(location.href).searchParams
    // let source = params.get('source')

    // // 传递参数 中 是否 source ( 不包含 )
    // if (data.hasOwnProperty('source') !== true) {
    //   // 地址 中是否 包含source
    //   if (source === null || source === undefined) {
    //     data['source'] = webSource
    //   } else {
    //     data['source'] = source
    //   }
    // }

    // 数据排序
    let dataKeyArr = []
    for (var i in data) {
      dataKeyArr.push(i)
    }
    dataKeyArr.sort()

    // 组合对象
    let json = {}
    let impStr = ''
    for (var j in dataKeyArr) {
      json[dataKeyArr[j]] = data[dataKeyArr[j]]
      impStr += data[dataKeyArr[j]]
    }
    // console.log(json)
    // console.log(impStr)
    // 加密
    json['sign'] = that.$md5(impStr + lfSignKey)
    return json
  },
  sourceSet: function (s) {
    var sourceCom = localStorage.getItem('source')
    if (sourceCom !== null && sourceCom !== '' && sourceCom !== undefined && sourceCom !== 'undefined' && sourceCom !== 'null') {
      sourceCom = localStorage.getItem('source')
    } else {
      sourceCom = s
    }
    return sourceCom
  },
  languageSet: function (s) {
    var languageCom = 'en'
    return languageCom
  },
  currencySet: function (s) {
    var currencyCom = localStorage.getItem('currencySet')
    if (currencyCom === null || currencyCom === '' || currencyCom === undefined || currencyCom === 'undefined' || currencyCom === 'null') {
      currencyCom = 'USD'
      localStorage.setItem('currencySet', currencyCom)
    } else {
      currencyCom = localStorage.getItem('currencySet')
    }
    return currencyCom
  },
  collapseSet: function (s) {
    var menuData = localStorage.getItem('menuSet')
    if (menuData === null || menuData === '' || menuData === undefined || menuData === 'undefined' || menuData === 'null') {
      menuData = collapseVal
      localStorage.setItem('menuSet', menuData)
    }
    if (menuData === 'true') {
      menuData = collapseVal
    } else {
      menuData = collapseValF
    }
    // console.log('common', menuData)
    return menuData
  },
  siteSet: function () {
    return 'hibeds'
  },
  sessionidGet: function (s) {
    // 生成统一的 sessionid
    var sessionid = sessionStorage.getItem('hotelQuotedPriceSesstionId')

    if (sessionid === null) {
      sessionid = ''
    } else {
      sessionid = sessionStorage.getItem('hotelQuotedPriceSesstionId')
    }
    return sessionid
  },
  addClass: function (s, name) {
    if (s === null) {
      return false
    }
    if (name) {
      s.className ? s.className = s.className + ' ' + name : s.className = name
    }
  },
  removeClass: function (s, name) {
    if (s === null) {
      return false
    }
    let classArr = s.className.split(' ')
    let index = classArr.indexOf(name)
    if (index > -1) {
      classArr.splice(index, 1)
    }
    s.className = classArr.join(' ')
  },
  tokenValid: function () {
    var token = localStorage.getItem('token')
    let locationHref = window.document.location.href
    if (token === undefined || token === null || token === 'null') {
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    } else {
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {'token': token, 'time': time}
      var data = this.common.encryptionData(dataJson, this)
      getUserInfo(data).then(res => {
        if (res.flag !== '200') {
          localStorage.removeItem('token')
          // localStorage.removeItem('getCookie')
          localStorage.removeItem('sessionid')
        }
      })
    }
  },
  isMobile: function () {
    var ismobile = false
    if (document.documentElement.clientWidth < 992) {
      ismobile = true
    }
    return ismobile
  },
  isWechat: function () {
    return navigator.userAgent.indexOf('MicroMessenger') !== -1
  },
  getWechatTransferPage (appid) {
    return encodeURIComponent('https://www.roompai.com/login/wechatLogin?domain=' + window.location.hostname + '&appid=' + appid + '&pagePath=' + window.location.pathname)
  },
  getWechatMobileAuthorizationUrl () {
    return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9e6cb7f7e34e656a&redirect_uri=' + this.getWechatTransferPage('wx9e6cb7f7e34e656a') + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
  },
  getWechatPcAuthorizationUrl (lang) {
    return 'https://open.weixin.qq.com/connect/qrconnect?appid=wx4a536782ca2e3f8c&scope=snsapi_login&redirect_uri=' + encodeURIComponent('https://www.roompai.com/login/wechatLogin?domain=' + window.location.hostname + '&appid=wx4a536782ca2e3f8c') + '&lang=' + lang + '#wechat_redirect'
  },
  getFacebookAuthorizationUrl () {
    return 'https://www.facebook.com/v18.0/dialog/oauth?response_type=token&client_id=680011454058903&scope=email%2Cpublic_profile&redirect_uri=' + encodeURIComponent('https://us.roompai.com/login/OAuth2?operation=FacebookAuth&domain=' + window.location.hostname)
  },
  defaultCheckDate: function () {
    var checkDate = []
    let d = new Date()
    var year = d.getFullYear()
    var month = d.getMonth()
    var tian = d.getDate()
    var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
    if (tian >= dayNum) {
      tian = 0
      month += 1
    }
    if (month > 12) {
      month = 12
      year += 1
    }
    var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
    checkDate.push(year + '-' + monthSelect + '-' + (parseInt(tian) + 1))
    checkDate.push(year + '-' + monthSelect + '-' + (parseInt(tian) + 2))

    return checkDate
  },
  // 识别码信息 开始
  canvasFingerprint: function () {
    // 创建一个隐藏的 Canvas 元素
    var canvas = document.createElement('canvas')
    canvas.width = 200
    canvas.height = 200
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    // 获取 2D 上下文
    var context = canvas.getContext('2d')
    // 在 Canvas 上绘制一些内容
    context.textBaseline = 'alphabetic'
    context.fillStyle = '#f60'
    context.fillRect(125, 1, 62, 20)
    context.fillStyle = '#069'
    context.font = '11pt no-real-font-123'
    context.fillText('Cwm fjordbank glyphs vext quiz', 2, 15)
    context.fillStyle = 'rgba(102, 204, 0, 0.2)'
    context.font = '18pt Arial'
    context.fillText('Cwm fjordbank glyphs vext quiz', 4, 45)
    // 获取 Canvas 数据
    var imageData = context.getImageData(0, 0, canvas.width, canvas.height)
    // 移除 Canvas 元素
    document.body.removeChild(canvas)

    var data = imageData.data
    // 计算指纹
    var hash = 0
    for (var i = 0; i < data.length; i += 4) {
      hash += data[i] + data[i + 1] + data[i + 2]
    }
    hash = hash.toString(16)

    return hash
  },
  getPluginsInfo: function (plugins) {
    const pluginInfo = []
    for (let i = 0; i < plugins.length; i++) {
      const plugin = plugins[i]
      // pluginInfo.push({
      //   name: plugin.name,
      //   filename: plugin.filename,
      //   description: plugin.description
      // })
      pluginInfo.push(plugin.name)
    }
    return pluginInfo.join(' | ')
  },
  getMimeTypesInfo: function (mimeTypes) {
    const mimeTypeInfo = []
    for (let i = 0; i < mimeTypes.length; i++) {
      const mimeType = mimeTypes[i]
      mimeTypeInfo.push({
        type: mimeType.type,
        description: mimeType.description,
        suffixes: mimeType.suffixes
      })
    }
    return mimeTypeInfo
  },
  getConnectionInfo: function (connection) {
    if (connection) {
      // return {
      //   type: connection.type,
      //   effectiveType: connection.effectiveType,
      //   downlink: connection.downlink,
      //   rtt: connection.rtt,
      //   saveData: connection.saveData
      // }
      return connection.effectiveType
    }
    return null
  },
  getClipboardInfo: function (clipboard) {
    if (clipboard) {
      return {
        read: typeof clipboard.read === 'function',
        write: typeof clipboard.write === 'function'
      }
    }
    return null
  },
  concatenateValues: function (obj) {
    let result = ''
    for (const key in obj) {
      result += obj[key] + ' !|! '
    }
    return result
  },
  generateWebGLFingerprint: function () {
    try {
      // 创建一个 WebGL 上下文
      const canvas = document.createElement('canvas')
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')

      if (!gl) {
        return 'WebGL not supported, unable to generate fingerprint.'
      }

      // 查询 WebGL 上下文的参数
      // const fingerprintData = {
      //   version: gl.getParameter(gl.VERSION),
      //   renderer: gl.getParameter(gl.RENDERER),
      //   vendor: gl.getParameter(gl.VENDOR),
      //   extensions: gl.getSupportedExtensions()
      // }
      // 生成指纹
      // const fingerprint = JSON.stringify(fingerprintData)
      const fingerprint = gl.getSupportedExtensions().join(' | ')

      return fingerprint
    } catch (error) {
      console.error('Error generating WebGL fingerprint:', error)
      return 'Error generating WebGL fingerprint.'
    }
  },
  webFont: function () {
    // 创建一个临时的 <span> 元素，用于测试字体
    const testElement = document.createElement('span')
    testElement.style.fontFamily = 'initial' // 设置为默认字体
    testElement.style.display = 'none'
    document.body.appendChild(testElement)
    const computedStyle = window.getComputedStyle(testElement)
    const defaultFont = computedStyle.fontFamily
    document.body.removeChild(testElement)

    // 打印系统字体列表
    return defaultFont
  },
  // 识别码信息 结束
  // 停止滚动
  stopScroll: function () {
    var mo = function (e) {
      e.preventDefault()
    }
    document.body.style.overflow = 'hidden'
    document.addEventListener('touchmove', mo, false)
  },
  // 允许滚动
  canScroll: function () {
    var mo = function (e) {
      e.preventDefault()
    }
    document.body.style.overflow = ''
    document.addEventListener('touchmove', mo, false)
  }
}



// WEBPACK FOOTER //
// ./src/util/common.js